// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3IqJC","content":"styles_content__3NOxy","tableWrap":"styles_tableWrap__1hDSU"};